/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_ErasureInputs */

const en_privacy_section_7_erasure = /** @type {(inputs: Privacy_Section_7_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to erasure`)
};

const lv_privacy_section_7_erasure = /** @type {(inputs: Privacy_Section_7_ErasureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiesības uz dzēšanu`)
};

/**
* | output |
* | --- |
* | "Right to erasure" |
*
* @param {Privacy_Section_7_ErasureInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_erasure = /** @type {((inputs?: Privacy_Section_7_ErasureInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_ErasureInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_erasure(inputs)
	return en_privacy_section_7_erasure(inputs)
});